import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'dashboard',
  menu: [
    {
      title: <FormattedMessage id="dashboard.menu.title" />,
      key: 'dashboard',
      url: '/dashboard',
      icon: 'icmn icmn-history',
      // roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/dashboard',
      async lazy() {
        const Comp = await import('./pages')
        return { Component: Comp.default }
      },
      // component: Loadable(() => import('./pages')),
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}

export { load as downloadTrips } from './redux/download/actions'
